import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; // ✅ Updated here
import Header from "./Header";
import Restaurants from "./Restaurants";
import Menu from "./Menu";
import axios from "axios";
import Footer from "./Footer";
import { baseURL } from "./api";

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate(); // ✅ Fixes the error
  const [priceType, setPriceType] = useState("sale");
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  const [loading, setLoading] = useState(true);

  // ... rest of your code


  // One-time reload logic
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
const isGuest = queryParams.get("guest");
const restaurantId = queryParams.get("restaurantId");

if (isGuest === "true" && restaurantId) {
  localStorage.setItem("role", "guest");
  localStorage.setItem("restaurantId", restaurantId);
  // Optional: redirect to Home only if not already there
  if (window.location.pathname !== "/") {
    window.location.href = "/";
  }
} else {
  const role = localStorage.getItem("role");
  if (!role) {
    navigate("/login");
  }
}
}, []);
  
  
  useEffect(() => {
    // 🚀 One-time reload
    if (!window.location.href.includes("reloaded=true")) {
      const url = new URL(window.location.href);
      url.searchParams.set("reloaded", "true");
      window.location.replace(url.toString());
    }
  }, []);
  

  useEffect(() => {
    const role = localStorage.getItem("role");
    const queryParams = new URLSearchParams(location.search);
    const urlPriceType = queryParams.get("priceType");

    let resolvedPriceType = "sale";

    if (role === "vendorSale") {
      resolvedPriceType = "sale";
    } else if (role === "vendor") {
      resolvedPriceType = "purchase";
    } else if (urlPriceType) {
      resolvedPriceType = urlPriceType;
    } else {
      resolvedPriceType = localStorage.getItem("priceType") || "sale";
    }

    setPriceType(resolvedPriceType);
    localStorage.setItem("priceType", resolvedPriceType);
  }, [location.search]);

  // 🔥 Guest auto-select logic
  useEffect(() => {
    const role = localStorage.getItem("role");
    const vendorId = localStorage.getItem("vendorId")?.trim();

    const fetchRestaurants = async () => {
      try {
        const res = await axios.get(`${baseURL}/getRestaurant`);
        const allRestaurants = res.data;

        const filtered = allRestaurants.filter(r => {
          const isVendorRestaurant = r.vendorId?.trim() === vendorId;
          const isDefaultRestaurant = r.default?.toString().toLowerCase() === "true";
          return isVendorRestaurant || isDefaultRestaurant;
        });

        if (role === "guest" && filtered.length > 0) {
          const openRestaurant = filtered.find(r => r.status === "Open") || filtered[0];
          localStorage.setItem("restaurantId", openRestaurant._id);
          setSelectedRestaurant(openRestaurant);
        }
      } catch (err) {
        console.error("Error loading restaurants:", err);
      } finally {
        setLoading(false);
      }
    };

    if (localStorage.getItem("role") === "guest") {
      fetchRestaurants();
    } else {
      setLoading(false); // non-guest case
    }
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="app">
      <Header />
      <main className="container mx-auto p-4">
        {selectedRestaurant ? (
          <Menu
            restaurant={selectedRestaurant}
            menuItems={selectedRestaurant.menuItems || []}
            priceType={priceType}
          />
        ) : (
          <Restaurants priceType={priceType} />
          
        )}

        <Footer/>
      </main>
    </div>
  );
};

export default Home;
